import type { HelpFile } from '../../types/help'
import { IconPickerTestIds } from '../../../testids/IconPickerTestIds'

export const iconPickerHelp: HelpFile = {
  docPage: '/docs/schema/types',
  texts: {
    [IconPickerTestIds.btnIconPicker]: null,
  },
}
